import React from 'react'

const Missing = () => {
  return (
    <main>
      Missing
    </main>
  )
}

export default Missing